<template>
  <BContainer v-if="ready" class="pb-5 pt-0">
      <BRow class="no-gutters d-flex py-4 justify-content-between align-items-center"
            :data-index="provider.index"
            :data-thumbnail="provider.url"
            :key="provider.url">

          <BCol md="6" sm="5" cols="12" :class="provider.url" class="accordion item-gallery-effect"
                role="tablist">
              <div class="card-image position-relative" v-b-modal="`modal_${provider.index}`">
                  <img class="__case-pic" width="100%" :src="getPicture(provider.index)"/>
              </div>
          </BCol>
          <BCol md="5" sm="7"
								cols="12"
                class="accordion p-3 item-gallery-effect "
                role="tablist">
              <h3 v-if="provider.founding_office"
                  class="text-primary font-weight-900 fs-xl-34px fs-lg-26px fs-20px">
                  {{ provider.founding_office }}
              </h3>
              <h2 v-if="provider.name" v-b-modal="`modal_${provider.index}`"
                  class="case_title font-weight-900 fs-xl-60px fs-lg-40px fs-md-34px fs-24px text-capitalize">
                  {{provider.name }}</h2>
              <h5 v-if="provider.nro_files" class="fs-xl-24px fs-md-20px fs-18px">
                  <strong>{{ $t('appContent.nro_leaks') }}:&nbsp;</strong>
                  <span class="font-weight-light">{{provider.nro_files }}</span>
              </h5>
              <h5 v-if="provider.time_period" class="fs-xl-24px fs-md-20px fs-18px">
                  <strong>{{ $t('appContent.time_period') }}:&nbsp;</strong>
                  <span class="font-weight-light">{{provider.time_period }}</span>
              </h5>
              <div class="w-100 mt-3">
                  <span class="btn-read-more font-weight-900"
                      v-b-modal="`modal_${provider.index}`"> {{ $t('modal.btn_read') }}</span>
              </div>
              <div class="w-100 mt-3">
                <SocialShare :title="`Find out more about ${provider.name}, one of the 14 offshore firms at the heart of @ICIJOrg’s #PandoraPapers investigation.`" :share-link="`https://www.icij.org/investigations/pandora-papers/secrecy-brokers?broker=${kebabCase(provider.name)}`"/>
              </div>
          </BCol>
          <Modal :provider="provider"/>
      </BRow>
      <IframModalSingle />
  </BContainer>
</template>



<script>

  import providerMixin from '@/mixins/provider'
  import utils from '@/mixins/utils'
  import IframModalSingle from '@/components/IframModalSingle.vue'
  import SocialShare from '@/components/SocialShare.vue'
  import Modal from '@/components/Modal.vue'
  import { kebabCase } from "lodash";

  export default {
      name: 'Provider',
      mixins: [utils, providerMixin],
      data() {
          return {
              ready: false
          }
      },
      components: {
          Modal,
          SocialShare,
          IframModalSingle
      },
      props: {
          content: {
              type: Object
          }
      },
      mounted() {
          this.$nextTick(() => {
              this.ready = true;
          })
      },
      methods: {
        kebabCase
      }
  }

</script>


<style lang="scss">
  .card-image {
      cursor: url(~@/assets/img/plus.svg), auto;;
      &:focus {
          outline: none;
      }
      .__case-pic {
          width: 100%;
          height: 40vh;
          object-fit: cover;
          object-position: center;
      }
      @media (max-width: 720px) {
          .__case-pic {
              height: 27vh;
          }
      }
  }
  .--btn-modal {
      border: none;
      background-color: unset;
      color: var(--app-color-red);
      text-decoration-line: underline;
      font-weight: bold;
      &:focus {
          outline: none;
      }
  }

  @media (min-width: 1465px) {
      .container, .container-sm, .container-md, .container-lg, .container-xl {
          max-width: 1400px;
      }
  }
  .text-end {
      text-align: end !important;
  }
    .btn-read-more{
      background-color: var(--app-color-red);
      color: white;
      padding: .3rem 1.5rem;
      transition: opacity 300ms;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: fit-content;
      &:hover,&:focus{
          opacity: .9;
      }
  }
</style>
